// extracted by mini-css-extract-plugin
module.exports = {"FilesComponent":"FilesComponent_FilesComponent__rF_45","linkWrapper":"FilesComponent_linkWrapper__gzvwF","fileSize":"FilesComponent_fileSize__y5B8y"};